import { UserDocumentViewModel } from '@/models'
import {
    APP_LOGOUT,
    DOCUMENTS_FAILURE,
    DOCUMENTS_GET_DOCUMENTS_FOR_ME_SUCCESS,
    DOCUMENTS_REQUEST,
} from '@/redux/actionTypes'

export interface DocumentsState {
    documents: UserDocumentViewModel[]
    loading: boolean
    errors: unknown[]
}

export type DocumentsAction =
    | { type: typeof DOCUMENTS_REQUEST }
    | { type: typeof DOCUMENTS_GET_DOCUMENTS_FOR_ME_SUCCESS, documents: UserDocumentViewModel[] }
    | { type: typeof DOCUMENTS_FAILURE, errors: unknown[] }
    | { type: typeof APP_LOGOUT }

const initialState: DocumentsState = {
    documents: [],
    loading: false,
    errors: [],
}

export const documentsReducer = (state: DocumentsState = initialState, action: DocumentsAction): DocumentsState => {
    switch (action.type) {
        case DOCUMENTS_REQUEST:
            return { ...state, loading: true }
        case DOCUMENTS_GET_DOCUMENTS_FOR_ME_SUCCESS:
            return {
                ...state, loading: false, documents: action.documents,
            }
        case DOCUMENTS_FAILURE:
            return {
                ...state, loading: false, errors: action.errors,
            }
        case APP_LOGOUT:
            return { ...initialState }
        default:
            return state
    }
}
